<template>
  <div class="create-order-container">
    <el-card class="order-card">
      
      <el-form ref="orderForm" :model="orderForm" :rules="orderRules" label-width="120px" label-position="right">
        <el-divider content-position="left">
          <span class="divider-title">项目信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="orderForm.projectName" placeholder="请输入项目名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择客户" prop="customerId">
              <el-select 
                v-model="orderForm.customerId" 
                filterable 
                placeholder="请选择客户" 
                style="width: 100%"
                :loading="loading.customers"
                @change="handleCustomerChange">
                <el-option
                  v-for="item in customerOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系人" prop="customerPerson">
              <el-input v-model="orderForm.customerPerson" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="customerPhone">
              <el-input v-model="orderForm.customerPhone" placeholder="请输入联系方式"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="地址" prop="customerAddress">
              <el-input v-model="orderForm.customerAddress" placeholder="请输入地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="样品数量" prop="testCount">
              <el-input-number 
                v-model="orderForm.testCount" 
                :min="1" 
                :max="999" 
                placeholder="请输入样品数量" 
                style="width: 100%"
                @change="updatePriceByTestCount"
                @input="handleInputChange">
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="预期完成时间" prop="expectedEndTime">
              <el-date-picker
                v-model="orderForm.expectedEndTime"
                type="date"
                placeholder="选择预期完成时间"
                value-format="yyyy-MM-dd"
                :picker-options="{
                  disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7; // 禁止选择今天之前的日期
                  }
                }"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注" prop="remarks" class="remarks-form-item">
              <el-input type="textarea" v-model="orderForm.remarks" :rows="3" placeholder="请输入备注信息" class="remarks-textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">商家信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选择商家" prop="merchantId">
              <el-select 
                v-model="orderForm.merchantId" 
                filterable 
                placeholder="请选择商家" 
                style="width: 100%"
                :loading="loading.merchants"
                @change="handleMerchantChange">
                <el-option
                  v-for="item in merchantOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="deviceId">
              <el-select 
                v-model="orderForm.deviceId" 
                filterable 
                placeholder="请选择仪器" 
                style="width: 100%"
                @change="handleEquipmentChange">
                <el-option
                  v-for="item in equipmentOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="仪器型号" prop="deviceModel">
              <el-input v-model="orderForm.deviceModel" placeholder="仪器型号" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参考价格" prop="guidePrice">
              <el-input v-model="orderForm.guidePrice" placeholder="参考价格" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="实际价格" prop="actualPrice">
              <el-input v-model="orderForm.actualPrice" placeholder="实际价格">
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="merchantPerson">
              <el-input v-model="orderForm.merchantPerson" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系方式" prop="merchantPhone">
              <el-input v-model="orderForm.merchantPhone" placeholder="请输入联系方式"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="merchantAddress">
              <el-input v-model="orderForm.merchantAddress" placeholder="请输入地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">测试要求附件</span>
        </el-divider>
        
        <el-form-item>
          <el-upload
            ref="upload"
            class="upload-demo"
            drag
            action=""
            :http-request="customUpload"
            multiple
            :headers="uploadHeaders"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-error="handleError"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :limit="10"
            :show-file-list="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">
              支持上传PDF、Word、Excel或图片格式文件，每个文件不超过200MB
              <span style="color: #F56C6C; margin-left: 10px;">必须先选择客户才能上传文件</span>
            </div>
          </el-upload>
        </el-form-item>
        
        <div class="file-list-container" v-if="fileList.length > 0">
          <h3 class="file-list-title">已上传文件列表</h3>
          <el-table
            :data="fileList"
            style="width: 100%"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
              <template slot-scope="scope">
                {{ scope.row.fileId || scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="200"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)" 
                  style="margin-left: 10px;">下载</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  style="color: #F56C6C; margin-left: 10px;"
                  @click="removeFile(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <el-form-item class="submit-buttons">
          <el-button type="primary" size="medium" @click="submitForm('orderForm')">提交订单</el-button>
          <el-button size="medium" @click="resetForm('orderForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'CreateOrder',
  props: {
    type: {
      type: String,
      default: '',
      validator: function(value) {
        // 类型只能是空或'forward'
        return ['', 'forward'].indexOf(value) !== -1
      }
    }
  },
  data() {
    return {
      orderForm: {
        projectName: '',
        customerId: '',
        merchantId: '',
        deviceId: '',
        orderStatus: '',
        customerAddress: '',
        customerPerson: '',
        customerPhone: '',
        merchantAddress: '',
        merchantPerson: '',
        merchantPhone: '',
        isRetest: 0,
        expectedEndTime: '',
        actualEndTime: '',
        trackSn: '',
        trackName: '',
        trackTime: '',
        isBackOrder: 0,
        backOrderType: this.type === 'forward' ? 1 : 0,  // 如果是转寄单，设置backOrderType为1
        backTrackSn: '',
        backPerson: '',
        backAddress: '',
        backPhone: '',
        backType: 0,
        guidePrice: '',
        actualPrice: '',
        deviceModel: '',  // 添加仪器型号字段
        remarks: '',
        testCount: 1,
        customerOrderSn: 0,
        orderFile: []
      },
      orderRules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        customerId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        customerPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        customerPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        customerAddress: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        testCount: [
          { required: true, message: '请输入样品数量', trigger: 'blur' }
        ],
        expectedEndTime: [
          { required: true, message: '请选择预期完成时间', trigger: 'change' }
        ],
        merchantId: [
          { required: true, message: '请选择商家', trigger: 'change' }
        ],
        deviceId: [
          { required: true, message: '请选择仪器', trigger: 'change' }
        ],
        merchantPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        merchantPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        merchantAddress: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        actualPrice: [
          { required: true, message: '请输入实际价格', trigger: 'blur' }
        ],
        orderFile: [
          { required: true, message: '请上传测试要求附件', trigger: 'change' }
        ]
      },
      customerOptions: [],
      merchantOptions: [],
      equipmentOptions: [],
      customerData: {},
      merchantData: {},
      fileList: [],
      uploadHeaders: {
        Authorization: localStorage.getItem('token') || ''
      },
      uploadingFiles: 0,
      loading: {
        customers: false,
        merchants: false
      },
      pendingUploads: undefined
    }
  },
  watch: {
    // 监听样品数量变化，重新计算价格
    'orderForm.testCount': function(newVal) {
      // 只有当仪器已选择时才重新计算价格
      if (this.orderForm.deviceId) {
        this.updatePriceByTestCount();
      }
    }
  },
  created() {
    // 初始化组件时加载客户和商家数据
    this.fetchCustomerList();
    this.fetchMerchantList();
  },
  methods: {
    // 获取客户列表
    fetchCustomerList() {
      this.loading.customers = true;
      adminApi.getCustomerList()
        .then(res => {
          console.log('客户列表数据:', res);
          if (res && Array.isArray(res)) {
            // 格式化数据为下拉框需要的格式
            this.customerOptions = res.map(item => ({
              value: item.id.toString(),
              label: `${item.companyName}`
            }));
            
            // 构建客户数据查找表，用于回填联系信息
            this.customerData = {};
            res.forEach(item => {
              this.customerData[item.id] = {
                contact: item.contactPerson || '',
                phone: item.phone || '',
                address: item.address || ''
              };
            });
          } else {
            this.$message.warning('获取客户列表失败');
          }
        })
        .catch(error => {
          console.error('获取客户列表错误:', error);
          this.$message.error('获取客户列表失败，请刷新页面重试');
        })
        .finally(() => {
          this.loading.customers = false;
        });
    },
    
    // 获取商家列表
    fetchMerchantList() {
      this.loading.merchants = true;
      adminApi.getMerchantList()
        .then(res => {
          console.log('商家列表数据:', res);
          if (res && Array.isArray(res)) {
            // 格式化数据为下拉框需要的格式
            this.merchantOptions = res.map(item => ({
              value: item.id.toString(),
              label: `${item.companyName || ''} - ${item.contactPerson || ''}`
            }));
            
            // 构建商家数据查找表，用于回填联系信息和仪器列表
            this.merchantData = {};
            res.forEach(item => {
              this.merchantData[item.id] = {
                contact: item.contactPerson || '',
                phone: item.phone || '',
                address: item.address || '',
                equipment: (item.deviceInfoList || []).map(device => ({
                  value: device.id.toString(),
                  label: device.deviceName,
                  referencePrice: device.price || '0.00',
                  actualPrice: device.price || '0.00',
                  deviceModel: device.deviceModel || '' // 添加仪器型号
                }))
              };
            });
          } else {
            this.$message.warning('获取商家列表失败');
          }
        })
        .catch(error => {
          console.error('获取商家列表错误:', error);
          this.$message.error('获取商家列表失败，请刷新页面重试');
        })
        .finally(() => {
          this.loading.merchants = false;
        });
    },
    
    handleCustomerChange(value) {
      if (this.customerData[value]) {
        const customerInfo = this.customerData[value];
        this.orderForm.customerPerson = customerInfo.contact;
        this.orderForm.customerPhone = customerInfo.phone;
        this.orderForm.customerAddress = customerInfo.address;
      }
    },
    handleMerchantChange(value) {
      if (this.merchantData[value]) {
        const merchantInfo = this.merchantData[value];
        this.orderForm.merchantPerson = merchantInfo.contact;
        this.orderForm.merchantPhone = merchantInfo.phone;
        this.orderForm.merchantAddress = merchantInfo.address;
        
        // 更新仪器选项
        this.equipmentOptions = merchantInfo.equipment || [];
        this.orderForm.deviceId = ''; // 清空已选仪器
        // 清空价格和仪器型号
        this.orderForm.guidePrice = '';
        this.orderForm.actualPrice = '';
        this.orderForm.deviceModel = '';
      } else {
        this.equipmentOptions = [];
      }
    },
    handleEquipmentChange(value) {
      // 根据选择的仪器回填价格和仪器型号
      if (this.orderForm.merchantId && value) {
        const merchantEquipment = this.merchantData[this.orderForm.merchantId]?.equipment || [];
        const selectedEquipment = merchantEquipment.find(item => item.value === value);
        
        if (selectedEquipment) {
          // 回填参考价格和实际价格，并乘以样品数量
          const basePrice = parseFloat(selectedEquipment.referencePrice) || 0;
          const totalPrice = basePrice * this.orderForm.testCount;
          
          this.orderForm.guidePrice = totalPrice.toFixed(2);
          this.orderForm.actualPrice = totalPrice.toFixed(2);
          
          // 回填仪器型号
          this.orderForm.deviceModel = selectedEquipment.deviceModel || '';
        }
      }
    },
    handleRemove(file) {
      // 这个方法由el-upload调用，对应上传组件的内置删除
      console.log('移除文件:', file);
      
      // 只有在文件确实存在于fileList中才进行处理和显示成功消息
      const index = this.fileList.findIndex(item => item.name === file.name);
      if (index !== -1) {
        // 获取要删除的文件
        const removedFile = this.fileList[index];
        
        // 找到对应文件并从fileList中删除
        this.fileList.splice(index, 1);
        
        console.log('尝试删除文件(handleRemove):', removedFile);
        
        // 同时从orderForm.orderFile中移除对应文件
        let orderFileIndex = -1;
        
        // 首先尝试通过fileId匹配
        if (removedFile.fileId) {
          orderFileIndex = this.orderForm.orderFile.findIndex(item => 
            item.fileId === removedFile.fileId);
        }
        
        // 如果通过fileId没找到，尝试通过文件名和URL匹配
        if (orderFileIndex === -1) {
          orderFileIndex = this.orderForm.orderFile.findIndex(item => 
            (item.fileName === removedFile.name || item.fileName === removedFile.fileId) &&
            (item.fileUrl === removedFile.url || (item.fileUrl && removedFile.url && 
            (item.fileUrl.includes(removedFile.name) || removedFile.url.includes(item.fileName)))));
        }
        
        // 如果还没找到，使用更宽松的匹配方式
        if (orderFileIndex === -1) {
          orderFileIndex = this.orderForm.orderFile.findIndex(item => 
            (item.fileName && removedFile.name && item.fileName.includes(removedFile.name)) || 
            (item.fileName && removedFile.fileId && item.fileName.includes(removedFile.fileId)) ||
            (removedFile.name && item.fileUrl && item.fileUrl.includes(removedFile.name)));
        }
        
        if (orderFileIndex !== -1) {
          console.log('删除orderForm中的文件:', this.orderForm.orderFile[orderFileIndex]);
          this.orderForm.orderFile.splice(orderFileIndex, 1);
          this.$message.success('文件已删除');
        } else {
          console.error('未找到要删除的文件在orderForm.orderFile中的索引', removedFile);
          this.$message.warning('文件已从列表中移除，但可能未能从表单数据中删除');
        }
      }
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    handleSuccess(response, file) {
      this.uploadingFiles--;
      console.log('上传成功，返回数据:', response);
      
      // 从返回数据中提取需要的信息
      let fileData = response;
      
      // 确保URL是完整的URL
      let fileUrl = fileData.url;
      // 如果URL不是以http开头，则拼接基础URL
      if (fileUrl && !fileUrl.startsWith('http') && !fileUrl.startsWith('blob:')) {
        fileUrl = adminApi.ApiUrl + (fileUrl.startsWith('/') ? '' : '/') + fileUrl;
      }
      
      // 创建一个新的文件对象添加到文件列表
      const newFile = {
        name: file.name,
        size: file.size,
        uploadTime: new Date(),
        status: 'success',
        url: fileUrl, 
        fileId: fileData.fileId,
        // 保存原始URL，以防后续需要
        originalUrl: fileData.url
      };
      
      // 将新文件添加到文件列表
      this.fileList.push(newFile);
      
      // 同时更新到orderForm.orderFile数组，用于表单提交
      this.orderForm.orderFile.push({
        fileId: fileData.fileId,
        fileName: fileData.fileId || file.name,
        fileUrl: fileUrl,
        filePath: fileData.path,
        fileSize: fileData.size
      });
      
      this.$message.success(`文件 ${file.name} 上传成功`);
    },
    handleError(err, file) {
      this.uploadingFiles--;
      console.error('文件上传失败:', err);
      this.$message.error(`文件 ${file.name} 上传失败，请重试`);
    },
    handleProgress(event, file) {
      // 显示上传进度
      console.log(`上传进度: ${parseInt(event.percent)}%`);
    },
    beforeUpload(file) {
      // 首先检查是否已选择客户
      if (!this.orderForm.customerId) {
        this.$message.error('请先选择客户再上传文件');
        return false;
      }
      
      // 检查文件大小
      const isLt200M = file.size / 1024 / 1024 < 200;
      if (!isLt200M) {
        this.$message.error('文件大小不能超过200MB!');
        return false;
      }
      
      // 可以在这里添加文件类型检查
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif'
      ];
      
      const isAllowedType = allowedTypes.includes(file.type);
      if (!isAllowedType) {
        this.$message.warning('请上传PDF、Word、Excel或图片格式的文件');
        // 返回false明确阻止上传
        return false;
      }
      
      // 标记文件为多文件上传的一部分（如果是拖放的多个文件）
      if (!file._multiUpload && this.$refs.upload && this.$refs.upload.uploadFiles.length > 1) {
        file._multiUpload = true;
      }
      
      return true;
    },
    customUpload(options) {
      const { file, onProgress, onSuccess, onError } = options;
      
      // 再次检查是否已选择客户
      if (!this.orderForm.customerId) {
        onError(new Error('请先选择客户再上传文件'));
        this.$message.error('请先选择客户再上传文件');
        return;
      }
      
      // 再次检查文件类型
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif'
      ];
      
      if (!allowedTypes.includes(file.type)) {
        onError(new Error('文件格式不支持'));
        this.$message.warning('请上传PDF、Word、Excel或图片格式的文件');
        return;
      }
      
      // 增加计数器
      this.uploadingFiles++;
      
      // 检查是否是多文件上传
      const isMultipleUpload = file._multiUpload === true || 
                              (this.$refs.upload && this.$refs.upload.uploadFiles.length > 1);
      
      if (isMultipleUpload && this.pendingUploads === undefined) {
        // 第一次遇到多文件上传，初始化待上传队列
        this.pendingUploads = {
          files: [],
          callbacks: [],
          timeout: null
        };
      }
      
      if (isMultipleUpload) {
        // 收集多文件上传的文件和回调
        console.log('收集多文件上传:', file.name);
        
        this.pendingUploads.files.push(file);
        this.pendingUploads.callbacks.push({
          onProgress, 
          onSuccess, 
          onError,
          fileName: file.name
        });
        
        // 清除之前的延迟执行
        if (this.pendingUploads.timeout) {
          clearTimeout(this.pendingUploads.timeout);
        }
        
        // 设置延迟执行，防止频繁调用API
        this.pendingUploads.timeout = setTimeout(() => {
          // 已收集了所有文件，执行批量上传
          console.log(`执行批量上传，共${this.pendingUploads.files.length}个文件`);
          
          const files = this.pendingUploads.files;
          const callbacks = this.pendingUploads.callbacks;
          
          // 如果最终只有一个文件，使用单文件上传
          if (files.length === 1) {
            console.log('虽然标记为多文件，但实际只有一个文件，使用单文件上传');
            
            const singleFile = files[0];
            const callback = callbacks[0];
            
            // 使用单文件上传API
            adminApi.uploadFile(singleFile, this.orderForm.customerId, (percent) => {
              callback.onProgress({ percent });
              this.handleProgress({ percent }, singleFile);
            }).then(response => {
              if (response && typeof response === 'object') {
                callback.onSuccess(response);
                this.handleSuccess(response, singleFile);
              } else {
                this.uploadingFiles--;
                callback.onError(new Error('接口返回格式不正确'));
                this.$message.error(`文件 ${singleFile.name} 上传失败：接口返回格式不正确`);
              }
            }).catch(error => {
              this.uploadingFiles--;
              callback.onError(error);
              this.handleError(error, singleFile);
            });
          } else {
            // 使用批量上传API
            adminApi.uploadFiles(files, this.orderForm.customerId, (percent) => {
              // 将上传进度通知给所有文件
              callbacks.forEach(cb => {
                cb.onProgress({ percent });
              });
              this.handleProgress({ percent }, { name: '多个文件' });
            }).then(response => {
              if (response && Array.isArray(response)) {
                // 处理每个文件的上传结果
                response.forEach((res, index) => {
                  const file = files[index];
                  const callback = callbacks[index];
                  if (res && typeof res === 'object') {
                    callback.onSuccess(res);
                    this.handleSuccess(res, file);
                  } else {
                    this.uploadingFiles--;
                    callback.onError(new Error('接口返回格式不正确'));
                    this.$message.error(`文件 ${callback.fileName} 上传失败：接口返回格式不正确`);
                  }
                });
              } else {
                // 批量上传返回了单个结果，尝试应用到所有文件
                callbacks.forEach((callback, index) => {
                  callback.onSuccess(response);
                  this.handleSuccess(response, files[index]);
                });
              }
            }).catch(error => {
              // 批量上传失败，通知所有文件
              callbacks.forEach(callback => {
                callback.onError(error);
              });
              this.uploadingFiles -= files.length;
              this.handleError(error, { name: '多个文件' });
            });
          }
          
          // 清空待上传队列
          this.pendingUploads = undefined;
        }, 50); // 短暂延迟收集多个文件
        
      } else {
        // 单文件上传 - 使用uploadFile接口
        console.log('单文件上传，使用uploadFile接口');
        
        adminApi.uploadFile(file, this.orderForm.customerId, (percent) => {
          onProgress({ percent });
          this.handleProgress({ percent }, file);
        }).then(response => {
          if (response && typeof response === 'object') {
            onSuccess(response);
            this.handleSuccess(response, file);
          } else {
            this.uploadingFiles--;
            onError(new Error('接口返回格式不正确'));
            this.$message.error(`文件 ${file.name} 上传失败：接口返回格式不正确`);
          }
        }).catch(error => {
          this.uploadingFiles--;
          onError(error);
          this.handleError(error, file);
        });
      }
    },
    formatFileSize(size) {
      if (!size) return '0 B';
      const units = ['B', 'KB', 'MB', 'GB'];
      let index = 0;
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024;
        index++;
      }
      return size.toFixed(2) + ' ' + units[index];
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 检查是否还有文件正在上传
          if (this.uploadingFiles > 0) {
            this.$message.warning('文件正在上传中，请等待上传完成后再提交');
            return;
          }
          
          // 表单验证通过，提交订单
          this.$confirm('确认提交订单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            // 提交订单前确保orderFile数据格式正确
            const orderData = JSON.parse(JSON.stringify(this.orderForm));
            
            // 确认fileList和orderForm.orderFile长度一致
            if (this.fileList.length !== orderData.orderFile.length) {
              console.warn('文件列表与表单文件数据不一致，正在尝试修正...');
              console.log('fileList:', this.fileList);
              console.log('orderForm.orderFile:', orderData.orderFile);
              
              // 重新同步文件列表和orderForm.orderFile
              orderData.orderFile = [];
              this.fileList.forEach(file => {
                orderData.orderFile.push({
                  fileId: file.fileId,
                  fileName: file.fileId || file.name,
                  fileUrl: file.url,
                  filePath: file.originalUrl || file.url,
                  fileSize: file.size
                });
              });
              
              console.log('修正后的orderForm.orderFile:', orderData.orderFile);
            }
            
            // 格式化日期为后端可接受的格式 (yyyy-MM-dd HH:mm:ss)
            if (orderData.expectedEndTime) {
              const date = new Date(orderData.expectedEndTime);
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              orderData.expectedEndTime = `${year}-${month}-${day} 23:59:59`;
            }
            
            // 设置附加字段
            orderData.orderStatus = 'NOT_SHIPPED'; // 默认为未邮寄状态
            
            // 使用adminApi提交订单
            console.log('提交订单数据:', orderData);
            adminApi.createOrder(orderData)
              .then(response => {
                this.$message({
                  type: 'success',
                  message: '订单提交成功!'
                });
                // 提交成功后跳转到未邮寄订单页面
                this.$router.push('/admin/orders/not-shipped');
              })
              .catch(error => {
                console.error('提交订单失败:', error);
                this.$message.error(error.message || '提交失败，请重试');
              });
          }).catch(() => {
            // 取消提交
          });
        } else {
          this.$message.error('表单填写有误，请检查!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.fileList = []
    },
    removeFile(index) {
      const removedFile = this.fileList[index];
      this.fileList.splice(index, 1);
      
      console.log('尝试删除文件:', removedFile);
      
      // 同时从orderForm.orderFile中移除
      let orderFileIndex = -1;
      
      // 首先尝试通过fileId匹配
      if (removedFile.fileId) {
        orderFileIndex = this.orderForm.orderFile.findIndex(file => 
          file.fileId === removedFile.fileId);
      }
      
      // 如果通过fileId没找到，尝试通过文件名和URL匹配
      if (orderFileIndex === -1) {
        orderFileIndex = this.orderForm.orderFile.findIndex(file => 
          (file.fileName === removedFile.name || file.fileName === removedFile.fileId) &&
          (file.fileUrl === removedFile.url || (file.fileUrl && removedFile.url && 
          (file.fileUrl.includes(removedFile.name) || removedFile.url.includes(file.fileName)))));
      }
      
      // 如果还没找到，使用更宽松的匹配方式
      if (orderFileIndex === -1) {
        orderFileIndex = this.orderForm.orderFile.findIndex(file => 
          (file.fileName && removedFile.name && file.fileName.includes(removedFile.name)) || 
          (file.fileName && removedFile.fileId && file.fileName.includes(removedFile.fileId)) ||
          (removedFile.name && file.fileUrl && file.fileUrl.includes(removedFile.name)));
      }
      
      if (orderFileIndex !== -1) {
        console.log('删除orderForm中的文件:', this.orderForm.orderFile[orderFileIndex]);
        this.orderForm.orderFile.splice(orderFileIndex, 1);
        this.$message.success('文件已删除');
      } else {
        console.error('未找到要删除的文件在orderForm.orderFile中的索引', removedFile);
        this.$message.warning('文件已从列表中移除，但可能未能从表单数据中删除');
      }
    },
    handleInputChange(value) {
      // 使用input事件直接监听输入变化
      this.updatePriceByTestCount();
    },
    updatePriceByTestCount() {
      // 根据样品数量更新价格
      if (this.orderForm.merchantId && this.orderForm.deviceId) {
        const merchantEquipment = this.merchantData[this.orderForm.merchantId]?.equipment || [];
        const selectedEquipment = merchantEquipment.find(item => item.value === this.orderForm.deviceId);
        
        if (selectedEquipment) {
          // 重新计算价格
          const basePrice = parseFloat(selectedEquipment.referencePrice) || 0;
          const totalPrice = basePrice * this.orderForm.testCount;
          
          this.orderForm.guidePrice = totalPrice.toFixed(2);
          this.orderForm.actualPrice = totalPrice.toFixed(2);
          
          // 回填仪器型号
          this.orderForm.deviceModel = selectedEquipment.deviceModel || '';
        }
      }
    }
  }
}
</script>

<style scoped>
.create-order-container {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f5f7fa;
}

.order-card {
  width: 100%;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
}

.page-title {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 20px;
}

.page-title h2 {
  color: #303133;
  font-size: 20px;
  margin: 0 0 8px 0;
}

.page-title p {
  color: #909399;
  font-size: 14px;
  margin: 0;
}

.divider-title {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  position: relative;
  padding-left: 12px;
}

.divider-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 4px;
  background-color: #409EFF;
  border-radius: 2px;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-form-item__label {
  font-weight: bold;
  color: #606266;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload,
.el-textarea,
.el-input-number {
  width: 100%;
}

/* 两列布局 */
.form-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
}

.form-col {
  flex: 1;
  padding: 0 10px;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

/* 上传区域样式 */
.upload-demo {
  width: 100%;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.upload-demo:hover {
  border-color: #409EFF;
}

.upload-demo .el-upload {
  width: 100%;
}

.upload-demo .el-upload-dragger {
  width: 100%;
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
}

/* 文件列表样式 */
.file-list-container {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
  padding: 20px;
}

.file-list-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #303133;
  position: relative;
  padding-left: 12px;
  border-left: 3px solid #409EFF;
}

/* 备注文本域样式 */
.remarks-textarea textarea,
.remarks-form-item .el-textarea__inner {
  min-height: 120px;
  resize: vertical;
  font-family: inherit !important;
  font-size: 14px !important;
  color: #606266 !important;
  line-height: 1.5 !important;
}

/* 确保文本域与其他表单字段样式一致 */
.el-textarea textarea {
  font-family: inherit !important;
  font-size: 14px !important;
  color: #606266 !important;
  line-height: 1.5 !important;
}
</style> 